import React, { useEffect, useState } from 'react';
import Loginheader from '../Loginheader';
import Menu from '../Menu';
import { Container, Row, Col, Button, Form, Badge, Table, Tabs, Tab } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faInfoCircle, faTrash } from '@fortawesome/free-solid-svg-icons';
import * as Common from '../Common';
import $ from "jquery";
import Dialog from '../Dialog';
import DatePicker from 'react-datepicker';
import "../../../node_modules/react-datepicker/dist/react-datepicker.css";
import { faEye } from '@fortawesome/free-regular-svg-icons';
import * as Picklist from "../Picklist";
import AsyncSelect from 'react-select/async';

const Upload_utr = () => {

    var msg = [], i = 0;
    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);
    const [scrMode, setScrMode] = useState('');
    const [userRight, setUserRight] = useState([]);
    const [entityType, setEntityType] = useState(sessionStorage.entityType);
    const [entityId, setEntityId] = useState(sessionStorage.entityId);
    const [key, setKey] = useState("UTRUPLOAD");

    // UTR UPLOAD
    const [isClickedUpload, setIsClickedUpload] = useState(false);
    const [utrFile, setUtrFile] = useState("");
    const [urtData, setUtrData] = useState([]);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [uTRRight, setUTRRight] = useState([]);
    const [srchRef, setSrchRef] = useState("");
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [utrLimit, setUtrLimit] = useState('50');

    // KNOCKOFF
    const [srchKnockoffRef, setSrchKnockoffRef] = useState("");
    const [knockoffFromDate, setKnockoffFromDate] = useState(new Date());
    const [knockoffToDate, setKnockoffToDate] = useState(new Date());
    const [knockoffLimit, setKnockoffLimit] = useState('50');
    const [knockoffAgent, setKnockoffAgent] = useState("0");
    const [ddKnockoffAgentOptions, setDdKnockoffAgentOptions] = useState([]);
    const [knockoffData, setKnockoffData] = useState([]);
    const [viewKnockoffData, setViewKnockoffData] = useState([]);
    const [knockoffUTR, setKnockoffUTR] = useState(null);
    const [knockoffAmount, setKncokoffAmount] = useState("");
    const [utrKnockOffAmntData, setUtrKnockOffAmntData] = useState([]);
    const [utrSrno, setUtrSrno] = useState(0);
    const [knockoffType, setKnockoffType] = useState("O");

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'UTR'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    // setUserRight(resp);
                    return;
                } else {
                    navigate('/'); // no query right
                }
            });

            Common.callApi(Common.apiRight, [sid, 'all', 'UTR_UPLOAD'], (result) => {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUTRRight(resp);
                }
            });
            if (sessionStorage.entityType === "A") {
                setDdKnockoffAgentOptions([{ label: sessionStorage.entityname, value: sessionStorage.entityId }]);
                onChangeAgent(sessionStorage.entityId, sessionStorage.entityname);
            }
            if (sessionStorage.entityType === "B") {
                Common.callApi(Common.apiEntity, [sid, 'ddlistjsonagentselect'], function (result) {
                    let resp = JSON.parse(result);
                    setDdKnockoffAgentOptions(resp);
                });
            }
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);


    function showSearchOptions() {
        setMsgText("Search on : Reference Number");
        setMsgBox(true);
    }

    const handleUTRList = () => {
        $('.loader').show();
        const obj = {
            srchRef: srchRef,
            fromDate: Common.dateYMD(fromDate),
            toDate: Common.dateYMD(toDate),
            utrLimit: utrLimit,
        };
        Common.callApi(Common.apiUtr, [sid, 'getUtrList', JSON.stringify(obj)], (result) => {
            $('.loader').hide();
            let resp = JSON.parse(result);
            setUtrData(resp);
        });
    }

    const handleDelete = (srno) => {
        $('.loader').show();
        const obj = {
            srno: srno,
            srchRef: srchRef,
            fromDate: Common.dateYMD(fromDate),
            toDate: Common.dateYMD(toDate),
            utrLimit: utrLimit,
        };
        Common.callApi(Common.apiUtr, [sid, 'deleteUtr', JSON.stringify(obj)], (result) => {
            $('.loader').hide();
            let resp = JSON.parse(result);
            if (resp.msg !== "") {
                setUtrData(resp.utr);
            } else {
                setMsgText(resp.err);
                setMsgBox(true);
            }
        });
    }

    const handleUpload = () => {
        setIsClickedUpload(true);
    }

    function handleDownloadBadge() {
        $('.loader').show();
        var object1 = {
            srno: 23
        }
        Common.callDownloadApiPost1(Common.apiFormat, "post", [sid, 'utrUpload', JSON.stringify(object1)], (result) => {
            $('.loader').hide();
        });
    }

    const uploadFile = () => {
        $('.loader').show();
        if (utrFile === "") {
            $('.loader').hide();
            setMsgText("Please Select a File to Upload.");
            setMsgBox(true);
        } else {
            $('.loader').show();
            var tempArray = document.getElementById('fileToUpload').files[0].name.split('.');

            if (tempArray.length > 2) {
                $('.loader').hide();
                setMsgText("(.) not allowed in file name.");
                setMsgBox(true);
            } else if (document.getElementById('fileToUpload').files[0] === undefined) {
                $('.loader').hide();
                setMsgText("Please select a file to upload.");
                setMsgBox(true);
            } else if (document.getElementById('fileToUpload').files[0].size > 10 * 1024 * 1024) {  // 10 MB
                $('.loader').hide();
                setMsgText("Please select a file with in 10 MB size.");
                setMsgBox(true);
            } else {
                var object1 = {
                    sid: sid,
                    uploadType: 'UTR_UPLOAD',
                    srno: 0,
                    pageright: 'UTR_UPLOAD',
                    docid: 0,
                }

                Common.uploadApi(JSON.stringify(object1), 'fileToUpload', function (result) {
                    $('.loader').hide();
                    let resp = JSON.parse(result);
                    if (resp.msg !== "") {
                        setMsgText(resp.msg);
                        setMsgBox(true);
                    }
                    setIsClickedUpload(false);
                    setUtrFile("");
                });
            }
        }
    }

    const handleTabChange = (k) => {
        setKey(k);
    }

    function onChangeAgent(id, agnname) {
        setKnockoffAgent(id);
        // setReqAgentName(agnname);
    }

    const handleKnockoffList = () => {
        $('.loader').show();
        if (knockoffAgent == "0") {
            $(".loader").hide();
            setMsgText('Please Select Agent.');
            setMsgBox(true);
        } else {
            const obj = {
                srchRef: srchKnockoffRef,
                fromDate: Common.dateYMD(knockoffFromDate),
                toDate: Common.dateYMD(knockoffToDate),
                knockoffLimit: knockoffLimit,
                knockoffAgent: knockoffAgent,
                knockoffType: knockoffType
            };
            Common.callApi(Common.apiUtr, [sid, 'getKnockoffData', JSON.stringify(obj)], (result) => {
                $('.loader').hide();
                let resp = JSON.parse(result);
                setKnockoffData(resp);
            });
        }
    }

    function showKnockoffSearchOptions() {
        setMsgText("Search on : Reference Number, PAN, Remitter Name, LAN");
        setMsgBox(true);
    }

    const handleView = (srno) => {
        setScrMode('Q');
        $('.loader').show();
        const obj = {
            srno: srno,
            knockoffType: knockoffType
        };
        Common.callApi(Common.apiUtr, [sid, 'viewKnockoffData', JSON.stringify(obj)], (result) => {
            $('.loader').hide();
            let resp = JSON.parse(result);
            setViewKnockoffData(resp.outwardArr);
            setUtrKnockOffAmntData(resp.knockoffArr);
        });
    }

    const btnBack = () => {
        setScrMode('');
        handleKnockoffList();
        setKey('KNOCKOFF');
    }

    const handleUTRNumber = (value) => {
        setKnockoffUTR(value);
        const utr = value.id.split('^');
        setUtrSrno(utr[1]);
    }

    const handleAdd = () => {
        $(".loader").show();
        if (knockoffUTR === null || knockoffAmount === "") {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (knockoffUTR === null ? 'Select UTR' : '');
            msg[i++] = (knockoffAmount === "" ? 'Knockoff Amount' : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                utrSrno: utrSrno,
                outwardSrno: viewKnockoffData[0]?.req_srno || 0,
                knockoffAmount: knockoffAmount,
                knockoffType: knockoffType,
            };
            Common.callApi(Common.apiUtr, [sid, 'addKnockoffamnt', JSON.stringify(obj)], (result) => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                if (resp.err != "") {
                    setMsgText(resp.err);
                    setMsgBox(true);
                } else {
                    setUtrKnockOffAmntData(resp.knockoffArr);
                    setKnockoffUTR(null);
                    setKncokoffAmount('');
                }
            });
        }
    }

    const handleDeleteKnockoffAmount = (srno, utrSrno, knockoffAmnt, outwardSrno, inwardSrno) => {
        $(".loader").show();
        const obj = {
            srno: srno,
            utrSrno: utrSrno,
            amount: knockoffAmnt,
            outwardSrno: outwardSrno,
            inwardSrno: inwardSrno,
            knockoffType: knockoffType
        };
        Common.callApi(Common.apiUtr, [sid, 'deleteknockoffamount', JSON.stringify(obj)], (result) => {
            $(".loader").hide();
            let resp = JSON.parse(result);
            setUtrKnockOffAmntData(resp);
            knockoffUTR(null);
            setKncokoffAmount('');
        });
    }

    const handleKnockoffTypeChange = (v) => {
        setKnockoffType(v);
        setKnockoffData([]);
    }

    return (
        <>
            <Loginheader />
            <Menu />
            <Container fluid>
                <Row>&nbsp;</Row>
                <Tabs activeKey={key} defaultActiveKey="UTRUPLOAD" onSelect={k => handleTabChange(k)}>
                    <Tab eventKey="UTRUPLOAD" title="UTR Upload">
                        <Row>&nbsp;</Row>
                        <Row>
                            <Col>
                                <h4>UTR Upload</h4>
                            </Col>
                        </Row>
                        <Row>&nbsp;</Row>
                        <Row>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Search...<span className="handCursor colorThemeBlue" title="Help"
                                        onClick={(e) => showSearchOptions()}><FontAwesomeIcon icon={faInfoCircle} />
                                    </span></Form.Label>
                                    <Form.Control type="text" placeholder="Search..."
                                        maxLength={50} autoComplete="off"
                                        value={srchRef}
                                        onChange={(e) => Common.validateAlpNumSplValue(e.target.value, setSrchRef)}
                                    />
                                </Form.Group>
                            </Col>
                            {/* <Col className='col-md-3 col-6'>&nbsp;</Col> */}
                            {
                                srchRef.length == 0 ?
                                    <>
                                        {
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group >
                                                    <Form.Label>From Date</Form.Label>
                                                    <DatePicker className="form-control"
                                                        selected={fromDate}
                                                        onChange={(date) => setFromDate(date)}
                                                        isClearable
                                                        dateFormat="dd/MM/yyyy"
                                                        showYearDropdown
                                                        showMonthDropdown
                                                        useShortMonthInDropdown
                                                        placeholderText='From Date'
                                                        dropdownMode="select"
                                                        peekNextMonth
                                                        customInput={
                                                            <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                                        }
                                                    />
                                                </Form.Group>
                                            </Col>
                                        }

                                        <Col className='col-md-3 col-6'>
                                            <Form.Group >
                                                <Form.Label>To Date</Form.Label>
                                                <DatePicker className="form-control"
                                                    selected={toDate}
                                                    onChange={(date) => setToDate(date)}
                                                    isClearable
                                                    dateFormat="dd/MM/yyyy"
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    useShortMonthInDropdown
                                                    placeholderText='To Date'
                                                    dropdownMode="select"
                                                    peekNextMonth
                                                    customInput={
                                                        <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                                    }
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>&nbsp;</Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Limit </Form.Label>
                                                <Form.Select
                                                    value={utrLimit}
                                                    onChange={(e) => setUtrLimit(e.target.value)} >
                                                    <option value="50">50</option>
                                                    <option value="100">100</option>
                                                    <option value="ALL">ALL</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>

                                    </> : <>
                                        <Col>&nbsp;</Col>
                                        <Col>&nbsp;</Col>
                                    </>
                            }
                            <Col>&nbsp;</Col>
                        </Row>
                        <Row>&nbsp;</Row>
                        <Row>
                            <Col>
                                <Button variant="outline-success" className='buttonStyle' size='sm' onClick={() => handleUTRList()}>List</Button>{' '}
                                {
                                    (!isClickedUpload && uTRRight.query == "1") &&
                                    <>
                                        <Button variant="outline-success" size="sm" onClick={() => handleUpload()}>Upload UTR</Button>
                                    </>
                                }
                            </Col>
                        </Row>
                        {
                            isClickedUpload && <>
                                <Row>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group controlId="fileToUpload">
                                            <Form.Label>Choose File<span className="text-danger">*</span></Form.Label>
                                            <Form.Control type="file" value={utrFile} onChange={(e) => setUtrFile(e.target.value)} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>&nbsp;</Row>
                                <Row>
                                    <span>
                                        <Badge bg="secondary" className="handCursor" onClick={handleDownloadBadge}>Download <FontAwesomeIcon icon={faDownload} /></Badge>
                                    </span><br></br>
                                    <Col>
                                        <Button variant="outline-success" className='buttonStyle' size='sm' onClick={() => uploadFile()}>Submit</Button>{' '}
                                    </Col>
                                </Row>
                            </>
                        }
                        <Row>&nbsp;</Row>
                        {
                            urtData.length > 0 &&
                            <Row>
                                <Col>
                                    <Table responsive striped bordered>
                                        <thead>
                                            <tr>
                                                <tfd>&nbsp;</tfd>
                                                {/* <th>Srno</th>
                                                <th>Bank code</th> */}
                                                <th>Type</th>
                                                <th>Bank Name</th>
                                                <th>UTR</th>
                                                <th>Date</th>
                                                <th>Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                urtData.map((item, index) => (
                                                    <tr key={item.tru_utr_srno}>
                                                        <td>
                                                            <div className="colorThemeBlue">
                                                                <span className="handCursor" onClick={(e) => handleDelete(item.tru_utr_srno)}>
                                                                    <FontAwesomeIcon icon={faTrash} />
                                                                </span>&nbsp;
                                                            </div>
                                                        </td>
                                                        {/* <td>{item.tru_utr_srno}</td> */}
                                                        {/* <td>{item.tru_bankcode}</td> */}
                                                        <td>{item.tru_mtype === "I" ? "INWARD" : item.tru_mtype === "O" ? "OUTWARD" : ""}</td>
                                                        <td>{item.tru_bank_name}</td>
                                                        <td>{item.tru_refno}</td>
                                                        <td>{item.tru_date}</td>
                                                        <td>{item.tru_amnt}</td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        }
                    </Tab>
                    <Tab eventKey="KNOCKOFF" title="Knockoff">
                        <Row>&nbsp;</Row>
                        <Row>
                            <Col>
                                <h4>Knockoff</h4>
                            </Col>
                        </Row>
                        <Row>&nbsp;</Row>
                        {
                            scrMode === '' ?
                                <>
                                    <Row>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Search...<span className="handCursor colorThemeBlue" title="Help"
                                                    onClick={(e) => showKnockoffSearchOptions()}><FontAwesomeIcon icon={faInfoCircle} />
                                                </span></Form.Label>
                                                <Form.Control type="text" placeholder="Search..."
                                                    maxLength={50} autoComplete="off"
                                                    value={srchKnockoffRef}
                                                    onChange={(e) => Common.validateAlpNumSplValue(e.target.value, setSrchKnockoffRef)}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Agent<span className="mandatory">*</span></Form.Label>
                                                <Form.Select
                                                    value={knockoffAgent}
                                                    onChange={(e) => onChangeAgent(e.target.value, e.target[e.target.selectedIndex].text)}
                                                    disabled={entityType === 'A'} >
                                                    {ddKnockoffAgentOptions.map((res) =>
                                                        <option key={res.value} value={res.value}>{res.label}</option>
                                                    )}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        {/* <Col className='col-md-3 col-6'>&nbsp;</Col> */}
                                        {
                                            srchKnockoffRef.length == 0 ?
                                                <>
                                                    {
                                                        <Col className='col-md-3 col-6'>
                                                            <Form.Group >
                                                                <Form.Label>From Date</Form.Label>
                                                                <DatePicker className="form-control"
                                                                    selected={knockoffFromDate}
                                                                    onChange={(date) => setKnockoffFromDate(date)}
                                                                    isClearable
                                                                    dateFormat="dd/MM/yyyy"
                                                                    showYearDropdown
                                                                    showMonthDropdown
                                                                    useShortMonthInDropdown
                                                                    placeholderText='From Date'
                                                                    dropdownMode="select"
                                                                    peekNextMonth
                                                                    customInput={
                                                                        <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                                                    }
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                    }

                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group >
                                                            <Form.Label>To Date</Form.Label>
                                                            <DatePicker className="form-control"
                                                                selected={knockoffToDate}
                                                                onChange={(date) => setKnockoffToDate(date)}
                                                                isClearable
                                                                dateFormat="dd/MM/yyyy"
                                                                showYearDropdown
                                                                showMonthDropdown
                                                                useShortMonthInDropdown
                                                                placeholderText='To Date'
                                                                dropdownMode="select"
                                                                peekNextMonth
                                                                customInput={
                                                                    <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                                                }
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    {/* <Col className='col-md-3 col-6'>&nbsp;</Col>
                                        <Col className='col-md-3 col-6'>&nbsp;</Col> */}
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Type </Form.Label>
                                                            <Form.Select
                                                                value={knockoffType}
                                                                onChange={(e) => handleKnockoffTypeChange(e.target.value)} >
                                                                <option value="O">OUTWARD</option>
                                                                <option value="I">INWARD</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Limit </Form.Label>
                                                            <Form.Select
                                                                value={knockoffLimit}
                                                                onChange={(e) => setKnockoffLimit(e.target.value)} >
                                                                <option value="50">50</option>
                                                                <option value="100">100</option>
                                                                <option value="ALL">ALL</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>

                                                </> : <>
                                                    <Col>&nbsp;</Col>
                                                    <Col>&nbsp;</Col>
                                                </>
                                        }
                                        <Col>&nbsp;</Col>
                                    </Row>
                                    <Row>&nbsp;</Row>
                                    <Row>
                                        <Col>
                                            <Button variant="outline-success" className='buttonStyle' size='sm' onClick={() => handleKnockoffList()}>List</Button>{' '}
                                        </Col>
                                    </Row>
                                    <Row>&nbsp;</Row>
                                    {
                                        knockoffData.length > 0 &&
                                        <Row>
                                            <Col>
                                                {
                                                    knockoffType === "O" ?
                                                        <Table responsive striped bordered>
                                                            <thead>
                                                                <tr>
                                                                    <tfd>&nbsp;</tfd>
                                                                    <th>Srno</th>
                                                                    <th>Reference No</th>
                                                                    <th>Agent No</th>
                                                                    <th>ISD</th>
                                                                    <th>Quantity</th>
                                                                    <th>LAN</th>
                                                                    <th>PAN</th>
                                                                    <th>Remitter Name</th>
                                                                </tr>
                                                            </thead>
                                                            < tbody >
                                                                {
                                                                    knockoffData.map((item, index) => (
                                                                        <tr key={item.req_srno}>
                                                                            <td>
                                                                                <div className="colorThemeBlue">
                                                                                    <span className="handCursor" onClick={(e) => handleView(item.req_srno)}>
                                                                                        <FontAwesomeIcon icon={faEye} />
                                                                                    </span>&nbsp;
                                                                                </div>
                                                                            </td>
                                                                            <td>{item.req_srno}</td>
                                                                            <td>{item.req_refno}</td>
                                                                            <td>{item.req_agentno}</td>
                                                                            <td>{item.req_isd}</td>
                                                                            <td>{item.req_quantity}</td>
                                                                            <td>{item.req_loanaccountno}</td>
                                                                            <td>{item.req_pan}</td>
                                                                            <td>{item.req_remittername}</td>
                                                                        </tr>
                                                                    ))
                                                                }
                                                            </tbody>
                                                        </Table>
                                                        :
                                                        <Table responsive striped bordered>
                                                            <thead>
                                                                <tr>
                                                                    <tfd>&nbsp;</tfd>
                                                                    <th>Srno</th>
                                                                    <th>Inward Reference</th>
                                                                    <th>Agent</th>
                                                                    <th>ISD</th>
                                                                    <th>Quantity</th>
                                                                    <th>Zenith Refno</th>
                                                                    <th>Remitter Name</th>
                                                                </tr>
                                                            </thead>
                                                            < tbody >
                                                                {
                                                                    knockoffData.map((item, index) => (
                                                                        <tr key={item.reqi_srno}>
                                                                            <td>
                                                                                <div className="colorThemeBlue">
                                                                                    <span className="handCursor" onClick={(e) => handleView(item.reqi_srno)}>
                                                                                        <FontAwesomeIcon icon={faEye} />
                                                                                    </span>&nbsp;
                                                                                </div>
                                                                            </td>
                                                                            <td>{item.reqi_srno}</td>
                                                                            <td>{item.reqi_inwardrefno}</td>
                                                                            <td>{item.reqi_agentno}</td>
                                                                            <td>{item.reqi_isd}</td>
                                                                            <td>{item.reqi_quantity}</td>
                                                                            <td>{item.reqi_zenithrefno}</td>
                                                                            <td>{item.reqi_remittername}</td>
                                                                        </tr>
                                                                    ))
                                                                }
                                                            </tbody>
                                                        </Table>
                                                }
                                            </Col>
                                        </Row>
                                    }
                                </> :
                                <>
                                    <Row>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label> <b>Serial No : </b>{viewKnockoffData[0]?.req_srno}</Form.Label>
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label> <b>Reference Number : </b>{viewKnockoffData[0]?.req_refno}</Form.Label>
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label> <b>Agent : </b>{viewKnockoffData[0]?.req_agentno}</Form.Label>
                                            </Form.Group>
                                        </Col>
                                    </Row><Row>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label> <b>ISD : </b>{viewKnockoffData[0]?.req_isd}</Form.Label>
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label> <b>Quantity : </b>{viewKnockoffData[0]?.req_quantity}</Form.Label>
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>
                                                    <b>Total Amount : </b> {viewKnockoffData[0]?.total ? Number(viewKnockoffData[0].total).toFixed(2) : "0.00"}
                                                </Form.Label>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    {
                                        /*
                                    <Row>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>
                                                    Forex Amount : {viewKnockoffData[0]?.req_forex_amount != null
                                                        ? Number(viewKnockoffData[0].req_forex_amount).toFixed(2)
                                                        : "0.00"}
                                                </Form.Label>
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label> GST : {viewKnockoffData[0]?.req_gst}</Form.Label>
                                            </Form.Group>
                                        </Col>
                                    </Row><Row>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label> TCS : {viewKnockoffData[0]?.req_tcs}</Form.Label>
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label> Bank Charges : {viewKnockoffData[0]?.req_bankcharges}</Form.Label>
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label> Nostro Charges : {viewKnockoffData[0]?.req_nostrocharges}</Form.Label>
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label> Round Off : {viewKnockoffData[0]?.req_roundoff}</Form.Label>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    */ }
                                    <Row>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label> <b>LAN : </b>{viewKnockoffData[0]?.req_loanaccountno}</Form.Label>
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label> <b>PAN : </b>{viewKnockoffData[0]?.req_pan}</Form.Label>
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label> <b>Remitter Name : </b>{viewKnockoffData[0]?.req_remittername}</Form.Label>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <hr />
                                    <Row>&nbsp;</Row>
                                    <Row>
                                        <Col>
                                            <Button variant="outline-primary" size="sm" onClick={() => btnBack()}>Back</Button>&nbsp;
                                        </Col>
                                    </Row>
                                    <Row>&nbsp;</Row>
                                    <Row>
                                        <Col className='col-md-6 col-6'>
                                            <Form.Group>
                                                <Form.Label>UTR<span className="colorThemeRed">*</span></Form.Label>
                                                <AsyncSelect
                                                    cacheOptions={false}
                                                    defaultOptions={false}
                                                    value={knockoffUTR}
                                                    getOptionLabel={e => e.label + ' '}
                                                    getOptionValue={e => e.id}
                                                    loadOptions={(search) => Picklist.fetchUTRNoPicklist(search, knockoffType)}
                                                    onChange={handleUTRNumber}
                                                    onInputChange={Picklist.handleInputChange}
                                                    formatOptionLabel={Picklist.utrFormatOptionLabel}
                                                    components={{ Menu: Picklist.UtrKnockOffmenu }}
                                                >
                                                </AsyncSelect>
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group >
                                                <Form.Label>Knockoff Amount<span className="colorThemeRed">*</span></Form.Label>
                                                <Form.Control type="text" placeholder="Knockoff Amount" maxLength={50}
                                                    onChange={(e) => Common.validateDecValue(e.target.value, setKncokoffAmount)}
                                                    value={knockoffAmount} autoComplete="off" />
                                            </Form.Group>
                                        </Col>
                                        <Col style={{ marginTop: "34px" }}>
                                            <Button variant="outline-primary" size="sm" onClick={() => handleAdd()}>Add</Button>&nbsp;
                                        </Col>
                                    </Row>
                                    <Row>&nbsp;</Row>
                                    <Row>&nbsp;</Row>
                                    {
                                        utrKnockOffAmntData.length > 0 &&
                                        <Row>
                                            <Col>
                                                <Table responsive striped bordered>
                                                    <thead>
                                                        <tr>
                                                            <tfd>&nbsp;</tfd>
                                                            <th>UTR</th>
                                                            <th>Outward/Inward Srno</th>
                                                            <th>Amount</th>
                                                            <th>User Name</th>
                                                            <th>Status</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            utrKnockOffAmntData.map((item, index) => (
                                                                <tr key={item.truk_srno}>
                                                                    <td>
                                                                        <div className="colorThemeBlue">
                                                                            <span className="handCursor" onClick={(e) => handleDeleteKnockoffAmount(item.truk_srno, item.truk_utr_srno, item.truk_amnt, item.truk_outward_srno, item.truk_inward_srno)}>
                                                                                <FontAwesomeIcon icon={faTrash} />
                                                                            </span>&nbsp;
                                                                        </div>
                                                                    </td>
                                                                    <td>{item.tru_refno}</td>
                                                                    <td>{item.truk_outward_srno > 0 ? item.truk_outward_srno : item.truk_inward_srno}</td>
                                                                    <td>{item.truk_amnt}</td>
                                                                    <td>{item.um_username}</td>
                                                                    <td>{item.truk_active == '1' ? 'Active' : 'Inactive'}</td>
                                                                </tr>
                                                            ))
                                                        }
                                                    </tbody>
                                                </Table>
                                            </Col>
                                        </Row>
                                    }
                                </>
                        }
                    </Tab>
                </Tabs>
                <Row>&nbsp;</Row>
                <Row>&nbsp;</Row>
                <Row>&nbsp;</Row>
            </Container >
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
            </div>
        </>
    )
}

export default Upload_utr;
